export const SIGNUP_PENDING_HEADQUARTERS_MARKER = "__GT_SIGNUP_PENDING__";

export function headquartersValueForForm(value: string | null | undefined): string {
  if (value == null || value === SIGNUP_PENDING_HEADQUARTERS_MARKER) return "";
  return value;
}
